module.exports = __webpack_public_path__ + "client/img/s_item_04.c57e8ae4.png";